


































































































































































































































































































































































































































// vue
import {
    ref,
    computed,
    onMounted,
    defineComponent,
    watch,
} from '@vue/composition-api';

// store
import { useStore } from '@/store';

// components
import Layer from '@/vue3/components/layer-tree/Layer.vue';
import MapTypeSelector from '@/vue3/components/layer-tree/MapTypeSelector.vue';
import EventTypeSelector from '@/vue3/components/layer-tree/EventTypeSelector.vue';
import GeoRecordGrid from '@/vue3/components/geo-record-grid/GeoRecordGrid.vue';
import CompareMosaic from '@/vue3/components/layer-tree/CompareMosaic.vue';

// hooks
import { useService } from '@/vue3/api/services';
import { useColor } from '@/vue3/hooks/colorHook';
import { useMapbox } from '@/vue3/hooks/mapboxHook';
import { useTournamentBall } from '@/vue3/hooks/tournamentBallHook';
import { useNotify } from '@/vue3/hooks/notifyHook';
import { useAirtable } from '@/vue3/hooks/airtableHook';
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useLayerTree } from '@/vue3/hooks/layerTreeHook';
import { useMeasureRecord } from '@/vue3/hooks/measureRecordHook';
import { useLayerTreeOption } from '@/vue3/hooks/layerTreeOptionHook';
import { useCategoryIconHooks } from '@/vue3/hooks/geoRecordCategoryIconHook';

// models
import { Event } from '@/vue3/api/models';

// config
import airtableLayerConfig from '@/vue3/configs/table/airtableLayerConfig';

// primevue
import Tree from 'primevue/tree';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import InputSwitch from 'primevue/inputswitch';
import ProgressSpinner from 'primevue/progressspinner';
import Slider from 'primevue/slider';

// lib
import { Portal } from '@linusborg/vue-simple-portal';

export default defineComponent({
    components: {
        Tree,
        Layer,
        Dialog,
        Button,
        Portal,
        Checkbox,
        InputSwitch,
        GeoRecordGrid,
        Dropdown,
        ProgressSpinner,
        MapTypeSelector,
        EventTypeSelector,
        CompareMosaic,
        Slider,
    },
    props: {
        mapbox: {
            type: Object,
            default: null,
        },
        layerTree: {
            type: Object,
            default: null,
        },
        updateLayerTreeProperty: {
            type: Function,
            default: () => {},
        },
        utilityDrawer: {
            type: Object,
            default: null,
        },
        toolOptions: {
            type: Object,
            default: null,
        },
        setGeoRecords: {
            type: Function,
            default: null,
        },
        setMeasureRecords: {
            type: Function,
            default: null,
        },
        isComparingMosaic: {
            type: Boolean,
            default: false,
        },
        compareMapbox: {
            type: Object,
            default: null,
        },
        updateCompareMapboxProperty: {
            type: Function,
            default: () => {},
        },
        afterCompareLoadCallback: {
            type: Function,
            default: () => {},
        },
        updateUtilityDrawerState: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any, context: any) {
        // services
        const {
            getAllIconFiles,
            getDefaultStyle,
            getRenderSelection,
            getMapboxLayerTree,
            deleteRenderSelecton,
            updateRenderSelection,
            createRenderSelection,
            getInProgressEvents,
            getAllMeasureRecordsByCourseSchemaId,
        } = useService();

        // hooks
        const store = useStore();
        const { isLight } = useColor();
        const { successToast, warnToast } = useNotify();

        const {
            setMosaic,
            toggleMap3d,
            initMapStyle,
            toggleMapHillshade,
            getAllMosaicsByCourseSchemaID,
        } = useMapbox();

        const {
            treeToArray,
            initGeoRecordSource,
            initGeoRecordLayers,
            initGeoRecordExtrusion,
            initArchiveGeoRecordSource,
            setArchiveGeoRecordVisibility,
            removeGeoRecordLayers,
            setArchiveGeoRecordVisibilityByCategory,
            initGeoRecordArchiveExtrusion,
            removeGeoRecordArchiveExtrusionLayers,
        } = useGeoRecord();

        const {
            initMeasureRecordSource,
            initMeasureRecordLayers,
            setAllMeasureRecordVisibility,
            filterMeasureRecordAndAddSurroundingVertex,
        } = useMeasureRecord();

        const {
            toggleBuggyMarker,
            courseNodeSelected,
            isAllowBuggyTracker,
            courseNodeDeSelected,
            geoRecordNodeSelected,
            geoRecordNodeDeSelected,
            fetchGeoRecordLayerData,
            checkEuropeTourPermission,
            fetchGeoRecordArchiveLayerData,
            fetchGeoRecordArchiveTreeData,
            fetchGeoRecordArchiveEvents,
            checkMeasureRecordPermission,
        } = useLayerTree();

        const {
            genTreeKeyMap,
            refreshLayerTreeState,
            genTreeKeyMapGeoRecordTree,
            genTreeKeyMapCourseSetupNodes,
        } = useLayerTreeOption();

        const {
            airtableNodeToggle,
            isAirtableAvailable,
            initAirtableSourceAndLayer,
        } = useAirtable();

        const { getTournamentBall } = useTournamentBall();

        const { setAllTournamentBallVisibility } = useTournamentBall();

        const { initGeoRecordStyle } = useCategoryIconHooks();
        const { errorToast } = useNotify();

        // refs
        const layerCounter = ref(0);

        const mapStyle = ref('default');

        const isMap3d = ref(true);
        const isLoading = ref(false);
        const isLayerTree = ref(false);
        const isBuggyVisible = ref(false);
        const isMapHillshaded = ref(false);
        const isGeoRecordGridVisible = ref(false);
        const isMeasureRecordsVisible = ref(false);
        const isBuggyTrackerAvailable = ref(false);
        const isTournamentBallVisible = ref(false);
        const isEuropeTourEnabled = ref(false);
        const isTournamentActive = ref(false);
        const isArchiveTree = ref<boolean>(false);
        const isCompareMosaic = ref(props.isComparingMosaic);
        const isMobile = ref<boolean>(store.getters.isMobile);

        const courseMosaics = ref<any>([]);
        const courseMosaicsList = ref<any>([]);
        const archiveEvents = ref<Event[] | undefined>([]);

        const lastSatMosaicState = ref({ sat: false, mosaic: false });

        const airtableRecordTree = ref<any[]>(airtableLayerConfig);
        const layerData = ref();
        const userMosaic = ref();
        const userMapStyle = ref();
        const geoRecordTree = ref();
        const measureRecords = ref();
        const mapboxLayerTree = ref();
        const allCategoryIcons = ref();
        const europeTourCourseData = ref();
        const mapboxLayerState = ref();
        const selectedGeoRecordNodes = ref();
        const userLayerSelectionData = ref();
        const selectedCourseSetupNodes = ref();
        const measureRecordsAfterFilter = ref();
        const selectedAirtableRecordNodes = ref();
        const archiveGeoRecords = ref();
        const geoRecordArchiveTree = ref();
        const selectedGeoRecordArchiveNodes = ref();
        const archiveEventId = ref();
        const selectedComparedMosaic = ref();
        const mosaicOpacity = ref<number>(1);
        let intervalId;

        // computed
        const computeMosaicValue = computed({
            get: () => {
                return userMosaic.value;
            },
            set: (value) => {
                userMosaic.value = value;
                changeMosaic(value);
            },
        });

        // watchers
        watch(
            () => props.isComparingMosaic,
            () => {
                if (props.isComparingMosaic) {
                    isCompareMosaic.value = true;
                }
            },
        );

        watch(mosaicOpacity, (newValue) => {
            updateMosaicOpacity();
        });

        // methods
        const toggleBuggyData = (): void => {
            isBuggyVisible.value = !isBuggyVisible.value;
            toggleBuggyMarker(isBuggyVisible.value, props.mapbox.map);
        };

        const courseLayerCount = computed(() => {
            layerCounter.value = 0;
            if (!selectedCourseSetupNodes.value) return;

            for (const entry of Object.entries(
                selectedCourseSetupNodes.value,
            )) {
                const value = entry[1];
                if ((value as { checked: boolean })?.checked) {
                    layerCounter.value++;
                }
            }

            return layerCounter.value;
        });

        const getLatestGeoRecordTreeMap = () => {
            return Object.keys(selectedGeoRecordNodes.value)
                .filter((key) => {
                    return selectedGeoRecordNodes.value[key].checked;
                })
                .map((layer) => Number(layer));
        };

        /*
        const getMosaicAndSatellite = () => {
            return mapStyle.value === 'default' ? ['sat', 'mosaic'] : [];
            visibleLayers -> The column render_selection.permanent_layers will be used for saving sat, mosaic, fog, tee etc instead of render_selection.visible_layers
        };
        */

        const getLatestPermanentLayers = () => {
            return Object.keys(selectedCourseSetupNodes.value).filter((key) => {
                return selectedCourseSetupNodes.value[key].checked;
            });
        };

        const saveTreeState = async (
            hideSuccessMessage: boolean,
        ): Promise<void> => {
            isLoading.value = true;

            layerData.value = {
                account_id: store.getters.account.id,
                courseSchemaId: store.getters.currentCourseSchema.id,
                visibleLayers: [],
                visibleLayersKeys: [],
                visibleRecords: getLatestGeoRecordTreeMap(),
                measureRecords: isMeasureRecordsVisible.value,
                mosaic: userMosaic.value ? userMosaic.value.mbtiles : null,
                mapStyle: mapStyle.value,
                threeD: isMap3d.value,
                hillshade: isMapHillshaded.value,
                permanentLayers: getLatestPermanentLayers(),
                mosaicOpacity: mosaicOpacity.value,
            };
            userLayerSelectionData.value.id === 0
                ? await createRenderSelection(layerData.value)
                : await updateRenderSelection(layerData.value);

            if (!hideSuccessMessage) {
                successToast('Layer tree setting saved.');
                warnToast('Please refresh the browser.');
            }

            isLoading.value = false;
        };

        const deleteTreeState = async (): Promise<void> => {
            isLoading.value = true;
            await deleteRenderSelecton();
            successToast('Layer tree settings returned to default.');
            warnToast('Please refresh the browser.');
            isLoading.value = false;
        };

        const setIsLayerTree = (): void => {
            isLayerTree.value = !isLayerTree.value;
        };

        const setIsGeoRecordsVisible = (value: boolean): void => {
            isGeoRecordGridVisible.value = value;
        };

        const setIsMap3d = (): void => {
            isMap3d.value = !isMap3d.value;
            toggleMap3d(isMap3d.value, props.mapbox.map);
        };

        const setIsMapHillshaded = (): void => {
            isMapHillshaded.value = !isMapHillshaded.value;
            toggleMapHillshade(isMapHillshaded.value, props.mapbox.map);
        };

        const toggleMeasureRecords = (): void => {
            if (
                !checkMeasureRecordPermission() &&
                !isMeasureRecordsVisible.value
            ) {
                errorToast('Measure Record Permission Denied');
            }
            isMeasureRecordsVisible.value = !isMeasureRecordsVisible.value;
            setAllMeasureRecordVisibility(
                props.mapbox.map,
                isMeasureRecordsVisible.value,
            );
        };

        const initGeoRecordArchiveState = (): void => {
            selectedGeoRecordArchiveNodes.value = genTreeKeyMap(
                geoRecordArchiveTree.value,
                {},
                'key',
            );
        };

        const toggleArchivedGeoRecord = async (
            eventId: number,
        ): Promise<void> => {
            isLoading.value = true;
            archiveEventId.value = eventId;
            archiveGeoRecords.value = [];
            selectedGeoRecordArchiveNodes.value = [];

            if (archiveEventId.value) {
                archiveGeoRecords.value = await fetchGeoRecordArchiveLayerData(
                    archiveEventId.value,
                );
                if (archiveGeoRecords.value.length > 0) {
                    isArchiveTree.value = true;
                } else {
                    isArchiveTree.value = false;
                }

                await getGeoRecordArchiveTreeData(archiveEventId.value);
                initGeoRecordArchiveState();
                refershArchiveGeoRecordLayer();
                setArchiveGeoRecordVisibility(
                    props.mapbox.map,
                    archiveEventId.value,
                );
                initArchiveExtrusion(props.mapbox.map, archiveGeoRecords.value);
            } else {
                removeGeoRecordArchiveExtrusionLayers(props.mapbox.map);
                setArchiveGeoRecordVisibility(
                    props.mapbox.map,
                    archiveEventId.value,
                );
                isArchiveTree.value = false;
            }

            isLoading.value = false;
        };

        const initArchiveExtrusion = (map: any, archiveRecords: any) => {
            initGeoRecordArchiveExtrusion(map, archiveRecords);
        };

        const getGeoRecordArchiveTreeData = async (
            eventId: any,
        ): Promise<void> => {
            geoRecordArchiveTree.value = await fetchGeoRecordArchiveTreeData(
                eventId,
            );
        };

        const geoRecordArchiveNodeSelect = (): void => {
            setArchiveGeoRecordVisibilityByCategory(
                props.mapbox.map,
                selectedGeoRecordArchiveNodes.value,
            );
        };

        const courseNodeSelect = (node: any): void => {
            if (layerCounter.value > 100) {
                warnToast(
                    'Layer restriction exceeded. Please unselect some layers.',
                );
                return;
            }

            const isKeyLineView = mapStyle.value === 'greenbook';

            if (!isKeyLineView && (node.key == 'sat' || node.key == 'mosaic')) {
                lastSatMosaicState.value[node.key] = true;
            }

            courseNodeSelected(
                node,
                props.mapbox.map,
                mapboxLayerState.value,
                selectedCourseSetupNodes.value,
                isKeyLineView,
            );
        };

        const courseNodeDeSelect = (node: any): void => {
            const isKeyLineView = mapStyle.value === 'greenbook';

            if (!isKeyLineView && (node.key == 'sat' || node.key == 'mosaic')) {
                lastSatMosaicState.value[node.key] = false;
            }

            courseNodeDeSelected(
                node,
                props.mapbox.map,
                mapboxLayerState.value,
                isKeyLineView,
            );
        };

        const geoRecordNodeSelect = (node: any, fromfilter: boolean): void => {
            geoRecordNodeSelected(
                node,
                props.mapbox.map,
                geoRecordTree.value,
                fromfilter,
                mapboxLayerState.value,
                selectedGeoRecordNodes.value,
            );
        };

        const geoRecordNodeDeSelect = (
            node: any,
            fromfilter: boolean,
        ): void => {
            geoRecordNodeDeSelected(
                node,
                props.mapbox.map,
                geoRecordTree.value,
                fromfilter,
                mapboxLayerState.value,
                selectedGeoRecordNodes.value,
            );
        };

        const airtableNodeSelect = (node: any): void => {
            airtableNodeToggle(
                node,
                mapboxLayerState.value,
                props.mapbox.map,
                true,
            );
        };

        const airtableNodeDeSelect = (node: any): void => {
            airtableNodeToggle(
                node,
                mapboxLayerState.value,
                props.mapbox.map,
                false,
            );
        };

        const toggleTournamentBall = () => {
            isTournamentBallVisible.value = !isTournamentBallVisible.value;

            if (isTournamentBallVisible.value) {
                getTournamentBall(props.mapbox.map);
                intervalId = setInterval(async () => {
                    getTournamentBall(props.mapbox.map);
                }, 10000);
                context.emit('setTourIntervalId', intervalId);
            } else {
                clearInterval(intervalId);
            }

            mapboxLayerState.value['ball-position'].isVisible =
                isTournamentBallVisible.value;

            setAllTournamentBallVisibility(
                props.mapbox.map,
                isTournamentBallVisible.value,
            );
        };

        const changeMosaic = (mosaic: any): void => {
            userMosaic.value = mosaic;

            if (userMosaic.value != null) {
                const tileArr = ref<any>([]);

                let tiles =
                    `${store.state.MaptilerUrl}/data/` +
                    mosaic.key +
                    '/{z}/{x}/{y}.png';

                tileArr.value.push(tiles);

                if (mapStyle.value !== 'default' || !mosaic) return;

                setMosaic(props.mapbox.map, tileArr.value);
                updateMosaicOpacity();
            }
        };

        const updateMosaicOpacity = () => {
            if (props.mapbox.map.getLayer('mosaic')) {
                props.mapbox.map.setPaintProperty(
                    'mosaic',
                    'raster-opacity',
                    mosaicOpacity.value,
                );
            }
        };

        const updateGeoRecordDefaultColor = (isKeyLineView: boolean): void => {
            const geoRecordSource = props.mapbox.map.getSource('geo-records');
            const geoRecordFeatures = geoRecordSource._data.features;

            geoRecordFeatures.forEach((feature) => {
                const categoryId = feature.properties.geoRecordCategoryId;
                const defaultColor = '#ffffff';
                const keyLineColor = '#000000';

                feature.properties.color =
                    categoryId === 0
                        ? isKeyLineView
                            ? keyLineColor
                            : defaultColor
                        : feature.properties.color;
            });

            geoRecordSource.setData(geoRecordSource._data);
        };

        const getSatMosaicState = (isKeyLineView: boolean) => {
            let sat_state = 'none';
            let mosaic_state = 'none';

            if (isKeyLineView) {
                return { sat_state, mosaic_state };
            }

            (((mapboxLayerTree.value || [])[0] || {}).children || []).forEach(
                (x: { data: string; isVisible: boolean }) => {
                    if (
                        x.data == 'mosaic' &&
                        x.isVisible &&
                        lastSatMosaicState.value.mosaic
                    ) {
                        mosaic_state = 'visible';
                    } else if (
                        x.data == 'sat' &&
                        x.isVisible &&
                        lastSatMosaicState.value.sat
                    ) {
                        sat_state = 'visible';
                    }
                },
            );
            return { sat_state, mosaic_state };
        };

        const setMapStyle = (): void => {
            const isKeyLineView = mapStyle.value === 'greenbook';
            store.commit('setIsKeyLineView', isKeyLineView);

            const { sat_state, mosaic_state } =
                getSatMosaicState(isKeyLineView);

            props.mapbox.map.setLayoutProperty('sat', 'visibility', sat_state);
            props.mapbox.map.setLayoutProperty(
                'mosaic',
                'visibility',
                mosaic_state,
            );

            updateGeoRecordDefaultColor(isKeyLineView);

            Object.keys(selectedCourseSetupNodes.value).forEach((key) => {
                if (key === 'sat') {
                    selectedCourseSetupNodes.value[key].checked =
                        sat_state == 'visible' && lastSatMosaicState.value.sat;
                } else if (key === 'mosaic') {
                    selectedCourseSetupNodes.value[key].checked =
                        mosaic_state == 'visible' &&
                        lastSatMosaicState.value.mosaic;
                }
            });
        };

        const toggleMapStyle = (): void => {
            mapStyle.value =
                mapStyle.value === 'default' ? 'greenbook' : 'default';
            setMapStyle();
        };

        const handleUserMosaicSelection = (): void => {
            let selectedMosaicIndex = userLayerSelectionData.value.mosaic
                ? courseMosaicsList.value.findIndex(
                      (mosaic: any) =>
                          mosaic.mbtiles ===
                          userLayerSelectionData.value.mosaic,
                  )
                : undefined;

            changeMosaic(
                courseMosaicsList.value[
                    selectedMosaicIndex && selectedMosaicIndex > 0
                        ? selectedMosaicIndex
                        : 0
                ],
            );
        };

        const initCourseNodeLayers = (): void => {
            if (mapboxLayerTree.value && mapboxLayerTree.value.length) {
                mapboxLayerTree.value[0].children.forEach(
                    (child: { data: string; isVisible: boolean }) => {
                        const key = child.data;
                        if (key != 'sat' && key != 'mosaic') {
                            const visibility_state =
                                child.isVisible == false ? 'none' : 'visible';
                            props.mapbox.map.setLayoutProperty(
                                key,
                                'visibility',
                                visibility_state,
                            );
                        }
                    },
                );
            }
        };

        const updateMapStyleAndLayer = (): void => {
            if (!props.mapbox) return;
            mapStyle.value =
                userLayerSelectionData.value.mapStyle == ''
                    ? 'default'
                    : userLayerSelectionData.value.mapStyle;

            props.mapbox.map.setStyle(userMapStyle.value);

            props.mapbox.map.on('style.load', () => {
                handleUserMosaicSelection();
                initMapStyle(props.mapbox.map, {
                    isMap3d: isMap3d.value,
                    isMapHillshaded: isMapHillshaded.value,
                });

                initGeoRecordStyle(props.mapbox.map, allCategoryIcons.value);

                initMeasureRecordSource(
                    props.mapbox.map,
                    measureRecordsAfterFilter.value,
                    store.state.isMeters,
                    isMeasureRecordsVisible.value,
                );
                initMeasureRecordLayers(props.mapbox.map);

                let geoRecords = treeToArray(geoRecordTree.value);
                context.emit('setGeoRecords', geoRecords);
                context.emit('setMeasureRecords', measureRecords.value);

                initGeoRecordSource(
                    props.mapbox.map,
                    geoRecords,
                    mapboxLayerState.value,
                );

                initGeoRecordLayers(props.mapbox.map);
                initGeoRecordExtrusion(
                    props.mapbox.map,
                    geoRecords,
                    userLayerSelectionData.value.visibleRecords,
                );

                initAirtableSourceAndLayer(
                    props.mapbox.map,
                    mapboxLayerState.value,
                );

                initCourseNodeLayers();

                setMapStyle();
            });
        };

        const readCourseMosaicList = (): void => {
            courseMosaicsList.value.forEach((mosaic: any) => {
                courseMosaics.value.push(mosaic);
            });
        };

        const initDemAndHillshade = (): void => {
            isMap3d.value =
                userLayerSelectionData.value.id == 0
                    ? true
                    : userLayerSelectionData.value.threeD;
            isMapHillshaded.value = userLayerSelectionData.value.hillshade;
        };

        const initMeasureRecordVisibility = (): void => {
            isMeasureRecordsVisible.value =
                checkMeasureRecordPermission() &&
                userLayerSelectionData.value.id === 0
                    ? true
                    : userLayerSelectionData.value.measureRecords;

            measureRecordsAfterFilter.value =
                filterMeasureRecordAndAddSurroundingVertex(
                    measureRecords.value,
                    store.state.isMeters,
                );
        };

        const initMapboxLayerState = (): void => {
            mapboxLayerState.value = refreshLayerTreeState(
                geoRecordTree.value,
                mapboxLayerTree.value,
                userLayerSelectionData.value,
            );
            selectedCourseSetupNodes.value = genTreeKeyMapCourseSetupNodes(
                mapboxLayerTree.value,
                {},
                'key',
            );

            if (userLayerSelectionData.value.id === 0) {
                // If the course hasn't had any permanent layers saved before
                lastSatMosaicState.value = { sat: true, mosaic: true };
            } else {
                Object.keys(selectedCourseSetupNodes.value).forEach((key) => {
                    if (key == 'sat' || key == 'mosaic') {
                        lastSatMosaicState.value[key] =
                            selectedCourseSetupNodes.value[key].checked;
                    }
                });
            }

            /* If it's needed to handle courses where render_selection doesn't have any data saved before:
            if (userLayerSelectionData.value.id === 0) return;
            */
        };

        const initGeoRecordState = (): void => {
            selectedGeoRecordNodes.value = genTreeKeyMapGeoRecordTree(
                geoRecordTree.value,
                {},
                'key',
                userLayerSelectionData.value,
            );
        };

        const initAirtableState = (): void => {
            selectedAirtableRecordNodes.value = genTreeKeyMap(
                airtableRecordTree.value,
                {},
                'key',
            );
        };

        const initTournamentBallPositions = async () => {
            isEuropeTourEnabled.value = checkEuropeTourPermission();
            if (!isEuropeTourEnabled.value) {
                return;
            }

            europeTourCourseData.value = await getInProgressEvents(
                store.getters.currentCourseSchema.id,
            );

            if (
                !europeTourCourseData.value.courseSchemaId ||
                (europeTourCourseData.value.courseSchemaId &&
                    europeTourCourseData.value.courseSchemaId !=
                        store.getters.currentCourseSchema.id)
            ) {
                isTournamentActive.value = false;
                return;
            }

            isTournamentActive.value = true;

            isTournamentBallVisible.value = isTournamentActive.value;

            getTournamentBall(props.mapbox.map);

            intervalId = setInterval(async () => {
                getTournamentBall(props.mapbox.map);
            }, 10000);

            context.emit('setTourIntervalId', intervalId);
        };

        const checkBuggyAvailability = (): void => {
            isBuggyTrackerAvailable.value = isAllowBuggyTracker();
        };

        const fetchArchiveEvents = async () => {
            archiveEvents.value = await fetchGeoRecordArchiveEvents(
                store.getters.currentCourseSchema.id,
            );

            return archiveEvents.value;
        };

        const initLayerTreeComponent = async (): Promise<void> => {
            if (userLayerSelectionData.value.id === 0) {
                treeToArray(geoRecordTree.value).forEach((record: any) => {
                    userLayerSelectionData.value.visibleRecords.push(record.id);
                });
            }
            initMeasureRecordVisibility();
            checkBuggyAvailability();
            readCourseMosaicList();
            initDemAndHillshade();
            initMapboxLayerState();
            initGeoRecordState();
            initAirtableState();
            initTournamentBallPositions();
            fetchArchiveEvents();
            updateMapStyleAndLayer();

            if (props.isComparingMosaic) {
                isCompareMosaic.value = true;
            }
        };

        const refreshGeoRecordTreeAndState = async (
            geoRecordIdArray: any,
            isCreate: boolean,
        ): Promise<void> => {
            await refreshGeoRecordTree();
            refreshGeoRecordState();
            if (userLayerSelectionData.value.id != 0) {
                if (geoRecordIdArray && geoRecordIdArray.length > 0) {
                    geoRecordIdArray.forEach((geoRecordId) => {
                        if (
                            selectedGeoRecordNodes.value[geoRecordId] !=
                            undefined
                        ) {
                            selectedGeoRecordNodes.value[geoRecordId].checked =
                                isCreate;
                        }
                    });
                    saveTreeState(true);
                }
            }
        };

        const refreshGeoRecordState = (): void => {
            initGeoRecordState();
        };

        const refreshGeoRecordTree = async (): Promise<void> => {
            const getRecordId = (record: any) => record.id;

            if (!geoRecordTree.value) return;

            isLoading.value = true;

            userLayerSelectionData.value = await getRenderSelection(
                store.getters.currentCourseSchema.id,
            );
            const geoRecordTreeKeysOld = treeToArray(geoRecordTree.value).map(
                getRecordId,
            );

            geoRecordTree.value = await fetchGeoRecordLayerData();

            const geoRecordTreeKeysNew = treeToArray(geoRecordTree.value).map(
                getRecordId,
            );

            const difference = geoRecordTreeKeysNew.filter(
                (x) => !geoRecordTreeKeysOld.includes(x),
            );

            difference.forEach((recordId) => {
                selectedGeoRecordNodes.value[recordId] = {
                    checked: true,
                };
            });

            mapboxLayerState.value = refreshLayerTreeState(
                geoRecordTree.value,
                mapboxLayerTree.value,
                userLayerSelectionData.value,
            );

            isLoading.value = false;
        };

        const refershArchiveGeoRecordLayerTree = async (): Promise<void> => {
            if (archiveEventId.value) {
                toggleArchivedGeoRecord(archiveEventId.value);
            }
        };

        const fetchMeasureRecordData = async () => {
            let measureRecord: any = {};
            try {
                measureRecord = await getAllMeasureRecordsByCourseSchemaId(
                    store.getters.currentCourseSchema.id,
                );
                return measureRecord;
            } catch (error) {
                return null;
            }
        };

        const refershArchiveGeoRecordLayer = async (): Promise<void> => {
            isLoading.value = true;

            removeGeoRecordLayers(props.mapbox.map);

            if (props.mapbox.map.getSource('geo-records-archive')) {
                props.mapbox.map.removeSource('geo-records-archive');
            }

            initGeoRecordStyle(props.mapbox.map, allCategoryIcons.value);

            initArchiveGeoRecordSource(
                props.mapbox.map,
                archiveGeoRecords.value,
            );

            initGeoRecordLayers(props.mapbox.map);

            isLoading.value = false;
        };

        const fetchLayerTreeData = async (): Promise<void> => {
            try {
                const [
                    userSelectionData,
                    mapStyleData,
                    courseMosaicData,
                    measureRecordData,
                    mapboxLayerTreeData,
                    geoRecordLayersData,
                    geoRecordIconData,
                ] = await Promise.all([
                    getRenderSelection(store.getters.currentCourseSchema.id),
                    getDefaultStyle(
                        store.getters.currentCourseSchema.id,
                        mapStyle.value,
                    ),
                    getAllMosaicsByCourseSchemaID(
                        store.getters.currentCourseSchema.id,
                    ),
                    fetchMeasureRecordData(),
                    getMapboxLayerTree(store.getters.currentCourseSchema.id),
                    fetchGeoRecordLayerData(),
                    getAllIconFiles(),
                    //getBuggyConfig(),
                    //getAirtableData(),
                ]);

                userLayerSelectionData.value = userSelectionData;
                mosaicOpacity.value = userSelectionData.mosaicOpacity ?? 1;
                userMapStyle.value = mapStyleData;
                courseMosaicsList.value = courseMosaicData;
                measureRecords.value = measureRecordData;
                mapboxLayerTree.value = mapboxLayerTreeData;
                geoRecordTree.value = geoRecordLayersData;
                allCategoryIcons.value = geoRecordIconData;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        const toggleCompareMosaic = (value: any) => {
            isCompareMosaic.value = !isCompareMosaic.value;
            selectedComparedMosaic.value = value;
        };

        // lifecycle
        onMounted(async (): Promise<void> => {
            isLoading.value = true;
            await fetchLayerTreeData();
            initLayerTreeComponent();
            isLoading.value = false;
        });

        return {
            isLight,
            isMap3d,
            mapStyle,
            isLoading,
            userMosaic,
            setIsMap3d,
            isLayerTree,
            saveTreeState,
            courseMosaics,
            geoRecordTree,
            isBuggyVisible,
            setIsLayerTree,
            toggleMapStyle,
            toggleBuggyData,
            MapTypeSelector,
            isMapHillshaded,
            mapboxLayerTree,
            deleteTreeState,
            courseLayerCount,
            courseNodeSelect,
            airtableNodeSelect,
            airtableRecordTree,
            setIsMapHillshaded,
            computeMosaicValue,
            courseNodeDeSelect,
            geoRecordNodeSelect,
            isAirtableAvailable,
            airtableNodeDeSelect,
            toggleMeasureRecords,
            refreshGeoRecordState,
            refreshGeoRecordTree,
            refreshGeoRecordTreeAndState,
            geoRecordNodeDeSelect,
            setIsGeoRecordsVisible,
            isGeoRecordGridVisible,
            selectedGeoRecordNodes,
            isMeasureRecordsVisible,
            isBuggyTrackerAvailable,
            selectedCourseSetupNodes,
            selectedAirtableRecordNodes,
            toggleTournamentBall,
            isTournamentBallVisible,
            isTournamentActive,
            archiveGeoRecords,
            toggleArchivedGeoRecord,
            refershArchiveGeoRecordLayer,
            geoRecordArchiveTree,
            selectedGeoRecordArchiveNodes,
            isArchiveTree,
            geoRecordArchiveNodeSelect,
            refershArchiveGeoRecordLayerTree,
            fetchArchiveEvents,
            archiveEvents,
            isCompareMosaic,
            toggleCompareMosaic,
            selectedComparedMosaic,
            initArchiveExtrusion,
            mosaicOpacity,
            updateMosaicOpacity,
            isMobile,
        };
    },
});
